export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7054.f71499df.jpg";